import { ErrorResponse } from "../responses/ErrorResponse";

export class NotFoundError extends ErrorResponse {
    public message: string;
}



// WEBPACK FOOTER //
// ./src/providers/api/errors/NotFoundError.ts